<template>
  <v-container class="hold-log-admin">
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <h1>Registration hold log</h1>
        <deadlines-hold-log-tabs />
        <p class="lede">
          Festival year <strong>{{ year }}</strong>.
          Every tap that tries to save a stay — held or sold out — with server time (to the millisecond), IP, and location when Google sends it.
        </p>
        <p class="muted">
          Location is city-level from IP (not a street address). Email is filled in if they already typed it or were logged in.
        </p>

        <p v-if="loadError" class="error-banner">{{ loadError }}</p>
        <p v-if="loading" class="muted">Loading…</p>

        <table v-else class="log-table">
          <thead>
            <tr>
              <th>Time (local)</th>
              <th>UTC</th>
              <th>Result</th>
              <th>Stay</th>
              <th>Email</th>
              <th>Location</th>
              <th>IP</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in rows" :key="row.id" :class="'result-' + row.result">
              <td class="nowrap">{{ formatLocal(row.createdAt) }}</td>
              <td class="muted nowrap">{{ row.atIso || '—' }}</td>
              <td>
                <strong>{{ row.result === 'sold_out' ? 'Sold out' : 'Held' }}</strong>
                <span v-if="row.code" class="muted"> {{ row.code }}</span>
              </td>
              <td>{{ row.room || '—' }}</td>
              <td>{{ row.email || '—' }}</td>
              <td>{{ locationLabel(row) }}</td>
              <td class="mono">{{ row.ip || '—' }}</td>
            </tr>
            <tr v-if="!rows.length">
              <td colspan="7" class="muted">No hold attempts yet this year.</td>
            </tr>
          </tbody>
        </table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { db } from '@/firebase'
import { IABF_REGISTRATION_YEAR } from '@/config/iabf-event'
import DeadlinesHoldLogTabs from '@/components/iabf/DeadlinesHoldLogTabs.vue'

export default {
  name: 'HoldLogAdmin',
  components: { DeadlinesHoldLogTabs },
  data () {
    return {
      loading: true,
      loadError: '',
      rows: [],
      unsub: null
    }
  },
  computed: {
    year () {
      return this.$store.state.adminFestivalYear || IABF_REGISTRATION_YEAR
    }
  },
  watch: {
    year () {
      this.listen()
    }
  },
  created () {
    this.$store.commit('setLayout', 'iabf-layout')
    this.listen()
  },
  beforeDestroy () {
    this.stop()
  },
  methods: {
    stop () {
      if (typeof this.unsub === 'function') {
        this.unsub()
      }
      this.unsub = null
    },
    listen () {
      this.stop()
      this.loading = true
      this.loadError = ''
      const col = 'iabf-registration-hold-log-' + this.year
      this.unsub = db.collection(col).orderBy('createdAt', 'desc').limit(300)
        .onSnapshot(
          (snap) => {
            this.rows = snap.docs.map(doc => ({ id: doc.id, ...(doc.data() || {}) }))
            this.loading = false
          },
          (err) => {
            this.loadError = (err && err.message) || 'Could not load hold log.'
            this.loading = false
          }
        )
    },
    formatLocal (ms) {
      const n = Number(ms)
      if (!n) {
        return '—'
      }
      const d = new Date(n)
      const date = d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
      const time = d.toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' })
      const milli = String(d.getMilliseconds()).padStart(3, '0')
      return date + ' ' + time + '.' + milli
    },
    locationLabel (row) {
      const parts = [row.city, row.region, row.country].filter(p => p && p !== '?' && p !== 'ZZ')
      if (row.latLong) {
        parts.push(row.latLong)
      }
      return parts.length ? parts.join(', ') : '—'
    }
  }
}
</script>

<style scoped>
.hold-log-admin h1 {
  margin: 8px 0 8px;
}
.lede {
  font-size: 16px;
  line-height: 1.45;
  margin: 0 0 8px;
}
.muted {
  color: #5c5a63;
  font-size: 14px;
}
.error-banner {
  background: #fdeeee;
  color: #8b2e2e;
  padding: 10px 12px;
  border-radius: 8px;
}
.log-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 16px;
  font-size: 13px;
}
.log-table th,
.log-table td {
  text-align: left;
  padding: 8px 10px;
  border-bottom: 1px solid #e3e0e8;
  vertical-align: top;
}
.log-table th {
  font-size: 12px;
  color: #5c5a63;
  font-weight: 700;
}
.nowrap {
  white-space: nowrap;
}
.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: 12px;
}
.result-sold_out td {
  background: #fdeeee;
}
</style>
